/** Customer-service endpoints of the membership module, relative to `API_URL`. */
export const MEMBERSHIP_ENDPOINT = {
  me: 'customer/v1/memberships/me',
  plans: 'customer/v1/memberships/plans',
  charges: 'customer/v1/memberships/me/charges',
  purchase: 'customer/v1/memberships',
  confirmCard: 'customer/v1/memberships/me/confirm-card',
  cancel: 'customer/v1/memberships/me/cancel',
  changePlan: 'customer/v1/memberships/me/change-plan',
  cancelPlanChange: 'customer/v1/memberships/me/change-plan/cancel',
  changeCard: 'customer/v1/memberships/me/card',
  confirmCardChange: 'customer/v1/memberships/me/card/confirm',
} as const;
